import React from 'react';
import clsx from 'clsx';
import { NavLink, useMatch, useNavigate, useOutlet } from 'react-router-dom';
import { AnimatePresence } from 'motion/react';

interface PageNavigationRoute {
  index?: boolean;
  path: string;
  title: string;
  count?: number;
  hidden?: boolean;
}

interface PageNavigationProps {
  routes: PageNavigationRoute[];
}

export const PageNavigation = (props: React.PropsWithChildren<PageNavigationProps>) => {
  const outlet = useOutlet();
  const match = useMatch('/');
  const navigate = useNavigate();
  const routes = props.routes.filter((route) => !route.hidden);

  return (
    <div className="mt-2">
      <div className="sm:hidden">
        <label htmlFor="tabs" className="sr-only">
          Select a tab
        </label>
        <select
          id="tabs"
          name="tabs"
          value={routes.find((tab) => match?.pathname.includes(tab.path))?.path}
          onChange={(e) => navigate(e.currentTarget.value)}
          className="block w-full rounded-md border-neutral-300 py-2 pl-3 pr-10 text-base focus:border-primary-500 focus:outline-none focus:ring-primary-500 sm:text-sm"
        >
          {routes.map((tab) => (
            <option key={tab.path} value={tab.path}>
              {tab.title}
            </option>
          ))}
        </select>
      </div>
      <div className="hidden sm:block">
        <div className="border-b border-neutral-200">
          <nav aria-label="Tabs" className="-mb-px flex space-x-8">
            {routes.map((tab) => (
              <NavLink
                key={tab.path}
                to={tab.path}
                className={({ isActive }) =>
                  clsx(
                    isActive
                      ? 'border-primary-500 text-primary-600'
                      : 'border-transparent text-neutral-500 hover:border-neutral-200 hover:text-neutral-700',
                    'flex whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium'
                  )
                }
              >
                {({ isActive }) => (
                  <>
                    {tab.title}
                    {tab.count ? (
                      <span
                        className={clsx(
                          isActive
                            ? 'bg-primary-200/65 text-primary-600'
                            : 'bg-neutral-200 text-neutral-900',
                          'ml-3 hidden rounded-full px-2.5 py-0.5 text-xs font-medium md:inline-block'
                        )}
                      >
                        {tab.count}
                      </span>
                    ) : null}
                  </>
                )}
              </NavLink>
            ))}
          </nav>
        </div>
      </div>
      <div className="mt-8">
        <AnimatePresence mode="wait" initial>
          {outlet && React.cloneElement(outlet, {})}
        </AnimatePresence>
      </div>
    </div>
  );
};
